// extracted by mini-css-extract-plugin
module.exports = {"grid":"InstructionSteps-module--grid--240625"};